import { useNavigate, useSearch } from "@tanstack/react-router";
import { Logo } from "@vetbolso/ui";
import { useState } from "react";
import type { z } from "zod";
import { entrar, queryClient } from "../api.ts";
import type { BuscaLogin } from "../buscas.ts";
import { Aviso, Botao, Campo, Entrada } from "../ui.tsx";

export function PaginaLogin() {
  const { volta } = useSearch({ strict: false }) as z.infer<typeof BuscaLogin>;
  const navegar = useNavigate();
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  return (
    <div className="grid min-h-dvh place-items-center px-4">
      <form
        className="flex w-full max-w-sm flex-col gap-4 rounded-2xl border border-line bg-surface p-6"
        onSubmit={async (e) => {
          e.preventDefault();
          const f = new FormData(e.currentTarget);
          setEnviando(true);
          setErro(null);
          try {
            await entrar(String(f.get("email")), String(f.get("senha")));
            await queryClient.invalidateQueries({ queryKey: ["eu"] });
            navegar({ to: volta?.startsWith("/") && !volta.startsWith("/login") ? volta : "/" });
          } catch (x) {
            setErro(x instanceof Error ? x.message : "não foi possível entrar");
          } finally {
            setEnviando(false);
          }
        }}
      >
        <div className="flex items-center gap-3">
          <Logo tamanho={40} />
          <div>
            <h1 className="text-lg font-bold">VetBolso admin</h1>
            <p className="text-sm text-muted">Acesso da equipe editorial</p>
          </div>
        </div>
        {erro ? <Aviso>{erro}</Aviso> : null}
        <Campo rotulo="E-mail">
          <Entrada name="email" type="email" autoComplete="username" required />
        </Campo>
        <Campo rotulo="Senha">
          <Entrada name="senha" type="password" autoComplete="current-password" required minLength={10} />
        </Campo>
        <Botao type="submit" variante="primario" disabled={enviando}>
          {enviando ? "Entrando…" : "Entrar"}
        </Botao>
        <p className="text-xs text-muted">Contas da equipe são criadas pelo administrador.</p>
      </form>
    </div>
  );
}
